// Copyright (c) Move Closer 2022.
import gql from 'graphql-tag'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const CREATE_WISHLIST_FRAGMENT = gql`
    fragment CreateWishListFragment on WishlistOutput {
        name
        items_count
    }
`

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * TODO use dynamic pagination instead of a fixed pageSize
 */
export const CUSTOMER_WISHLIST_FRAGMENT = gql`
    fragment CustomerWishList on Wishlist {
        id
        items_count
        items_v2(currentPage: 1, pageSize: 999) {
            items {
                id
                quantity
                product {
                    uid
                    sku
                    name
                }
            }
        }
    }
`
